import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="font-heading text-2xl font-bold text-background-50 tracking-tight">asmr1</Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              沉浸式ASMR音频体验的首选平台。发现最优质的触发音合集、助眠放松与减压冥想内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/trigger-sounds" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">触发音合集</Link></li>
              <li><Link to="/category/sleep-aid" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">助眠放松</Link></li>
              <li><Link to="/category/stress-relief" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">减压冥想</Link></li>
              <li><Link to="/category/roleplay" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">角色扮演</Link></li>
              <li><Link to="/category/mouth-sounds" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">吃播口腔音</Link></li>
              <li><Link to="/category/nature-sounds" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">自然白噪音</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">联系我们</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200" rel="nofollow">隐私政策</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200" rel="nofollow">使用条款</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">关注我们</h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200" rel="nofollow" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200" rel="nofollow" aria-label="小红书">
                <i className="ri-booklet-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">&copy; {new Date().getFullYear()} asmr1. All rights reserved.</p>
          <p className="text-xs text-background-500">沉浸式ASMR体验入口 — 让每一次收听都带来深度放松</p>
        </div>
      </div>
    </footer>
  );
}